import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {exportReport} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import MuiTable from "../common/MuiTable";
import {
    legalActs, legalRegs,
    saveOrUpdateAct, saveOrUpdateReg,
    deleteAct, deleteReg, saveOrUpdateCop, deleteCop, legalCops
} from "../../util/PlanningApiUtils";
import {Spinner} from "../common/Spinner";
import {withStyles} from "@material-ui/styles";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    'input': {
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            background: 'yellow'
        }
    },
}));

const columns = [
    {
        title: 'Title of Act',
        field: 'title',
        type: "textarea",
    },
    {
        title: 'Link',
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: 'Date the Act was reviewed',
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: 'Comments',
        field: 'comments',
        type: "textarea",
    },
];

const regColumns = [
    {
        title: 'Title of the Regulation',
        field: 'title',
        type: "textarea",
    },
    {
        title: 'Link',
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: 'Date the Regulation was reviewed',
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: 'Comments',
        field: 'comments',
        type: "textarea",
    },
];

const coPColumns = [
    {
        title: 'Title of the Code of Practice',
        field: 'title',
        type: "textarea",
    },
    {
        title: 'Link',
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: 'Date the Code Of Practice was reviewed',
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: 'Comments',
        field: 'comments',
        type: "textarea",
    },
];

class Legal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            acts: [],
            regulations: [],
            cops: [],
            isLoading: true,
            show: false,
        };
        this.loadLegalActs = this.loadLegalActs.bind(this);
        this.loadLegalRegs = this.loadLegalRegs.bind(this);
        this.loadLegalCops = this.loadLegalCops.bind(this);
        this.handleSubmitAct = this.handleSubmitAct.bind(this);
        this.handleSubmitReg = this.handleSubmitReg.bind(this);
        this.handleSubmitCoP = this.handleSubmitCoP.bind(this);
        this.handleDeleteAct = this.handleDeleteAct.bind(this);
        this.handleDeleteReg = this.handleDeleteReg.bind(this);
        this.handleDeleteCoP = this.handleDeleteCoP.bind(this);
    }

    componentDidMount() {
        this.loadLegalActs();
        this.loadLegalRegs();
        this.loadLegalCops();
    }

    loadLegalActs() {
        legalActs()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    acts: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadLegalRegs() {
        legalRegs()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    regulations: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadLegalCops() {
        legalCops()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    cops: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleDeleteAct(data) {
        console.log('delete', data);
        deleteAct(data)
            .then(() => {
                this.loadLegalActs();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    handleDeleteReg(data) {
        console.log('delete', data);
        deleteReg(data)
            .then(() => {
                this.loadLegalRegs();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    handleDeleteCoP(data) {
        console.log('delete', data);
        deleteCop(data)
            .then(() => {
                this.loadLegalCops();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    isValid(newData) {
        /*let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;*/
        // for now its always valid
        return true;
    }

    handleSubmitAct(data) {
        saveOrUpdateAct(data)
            .then(() => {
                this.loadLegalActs();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleSubmitReg(data) {
        saveOrUpdateReg(data)
            .then(() => {
                this.loadLegalRegs();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleSubmitCoP(data) {
        saveOrUpdateCop(data)
            .then(() => {
                this.loadLegalCops();
                NotificationManager.success('Success', 'The Legal Requirements have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        const { state } = this;
        const { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div className={classes.form}>
            <Typography component="h2" variant="h5">
                <span style={{color: "darkblue"}}>
                    <p><b>LEGAL AND OTHER COMPLIANCE REQUIREMENTS</b></p>
                </span>
            </Typography>
            <MuiTable
                title="Acts"
                columns={columns}
                data={state.acts}
                onAdd={this.handleSubmitAct}
                onUpdate={this.handleSubmitAct}
                onDelete={this.handleDeleteAct}
                exportButton={!isDemo}
                onExport={() => exportReport('/planning/legal/act/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={isAuditor ? 'no' : 'yes'}
            />
            <br/>
            <MuiTable
                title="Regulations"
                columns={regColumns}
                data={state.regulations}
                onAdd={this.handleSubmitReg}
                onUpdate={this.handleSubmitReg}
                onDelete={this.handleDeleteReg}
                exportButton={!isDemo}
                onExport={() => exportReport('/planning/legal/regulation/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={isAuditor ? 'no' : 'yes'}
            />
            <br/>
            <MuiTable
                title="Code of Practice"
                columns={coPColumns}
                data={state.cops}
                onAdd={this.handleSubmitCoP}
                onUpdate={this.handleSubmitCoP}
                onDelete={this.handleDeleteCoP}
                exportButton={!isDemo}
                onExport={() => exportReport('/planning/legal/code_of-practice/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={isAuditor ? 'no' : 'yes'}
            />
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(Legal);
